import React, { useState, useEffect, useCallback } from "react";
import { Select } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import WorkflowNodeFilterForm from "./WorkflowNodeFilterForm";

const MATCH_CONDITION_OPTIONS = [
  { value: "All", label: "all" },
  { value: "At Least One", label: "at least one" },
];

const filterGroupStyle = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: "var(--sl-bg-tertiary)",
  padding: 16,
  borderRadius: 8,
};

const matchConditionStyle = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 8,
  marginBottom: 8,
  fontSize: 14,
  lineHeight: "20px",
  color: "var(--sl-text-primary)",
};

const WorkflowNodeFilterGroupForm = () => {
  const {
    setFiltersToDelete,
    selectedNodeFormState,
    setSelectedNodeFormState,
  } = useCustomCampaignShowContext();

  const filterGroup = selectedNodeFormState.filter_group;

  const [filtersAttributes, setFiltersAttributes] = useState(() =>
    _.cloneDeep(filterGroup.filters_attributes || [])
  );

  useEffect(() => {
    setFiltersAttributes(() => _.cloneDeep(filterGroup.filters_attributes || []));
  }, [selectedNodeFormState]);

  const setFilterFilterParams = useCallback((index, payload) => {
    setFiltersAttributes(prevFilters => {
      const newFilters = _.cloneDeep(prevFilters);
      newFilters[index].filter_params = payload;
      return newFilters;
    });

    setSelectedNodeFormState(prevState => {
      const newState = _.cloneDeep(prevState);
      const newFiltersAttributes = _.cloneDeep(newState.filter_group.filters_attributes || []);

      if (newFiltersAttributes[index]) {
        newFiltersAttributes[index].filter_params = payload;
      }

      return {
        ...newState,
        filter_group: {
          ...newState.filter_group,
          filters_attributes: newFiltersAttributes
        }
      };
    });
  }, [setSelectedNodeFormState]);

  const deleteFilter = useCallback((index) => {
    if (filtersAttributes[index]?.id) {
      setFiltersToDelete(prevFiltersToDelete =>
        [...prevFiltersToDelete, filtersAttributes[index].id]
      );
    }

    setFiltersAttributes(prevFilters => {
      const newFilters = _.cloneDeep(prevFilters);
      newFilters.splice(index, 1);
      return newFilters;
    });

    setSelectedNodeFormState(prevState => {
      const newState = _.cloneDeep(prevState);
      const newFiltersAttributes = _.cloneDeep(newState.filter_group.filters_attributes || []);

      newFiltersAttributes.splice(index, 1);
      return {
        ...newState,
        filter_group: {
          ...newState.filter_group,
          filters_attributes: newFiltersAttributes
        }
      };
    });
  }, [filtersAttributes, setFiltersToDelete, setSelectedNodeFormState]);

  const handleMatchConditionChange = useCallback((matchCondition) => {
    setSelectedNodeFormState(prevState => ({
      ..._.cloneDeep(prevState),
      filter_group: {
        ..._.cloneDeep(prevState.filter_group),
        match_condition: matchCondition
      }
    }));
  }, [setSelectedNodeFormState]);

  return (filtersAttributes.length ? (
    <div style={filterGroupStyle}>
      <div style={matchConditionStyle}>
        with
        <Select
          aria-label="Match condition"
          width={160}
          options={MATCH_CONDITION_OPTIONS}
          value={filterGroup.match_condition}
          onChange={handleMatchConditionChange}
        />
        of the following conditions
      </div>
      {filtersAttributes?.map((filter, i) => (
        <WorkflowNodeFilterForm
          key={filter.id || filter.tempId}
          index={i}
          filter={filter}
          setFilterFilterParams={setFilterFilterParams}
          deleteFilter={deleteFilter}
        />
      ))}
    </div>
  ) : null);
};

export default WorkflowNodeFilterGroupForm;
